// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"2d45a800","38":"db6968a1","182":"e64fa3f3","488":"af7a0b95"}[chunkId] + ".chunk.js";
};